// Kiosk dark/light theme — persisted in localStorage (`kiosk_theme`).
//
// The kiosk is touch-first and often runs on a fixed device, so the theme is
// a per-device preference rather than a per-user one. Default is dark (the
// original kiosk look); operators can flip to light from the top bar.

import { useState } from 'react';

export type KioskTheme = 'dark' | 'light';

const STORAGE_KEY = 'kiosk_theme';

function readStoredTheme(): KioskTheme {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

export interface UseKioskThemeResult {
  theme: KioskTheme;
  toggle: () => void;
}

export function useKioskTheme(): UseKioskThemeResult {
  const [theme, setTheme] = useState<KioskTheme>(readStoredTheme);

  const toggle = (): void => {
    setTheme((prev) => {
      const next: KioskTheme = prev === 'dark' ? 'light' : 'dark';
      try {
        localStorage.setItem(STORAGE_KEY, next);
      } catch {
        // Private-mode / storage-disabled — keep the in-memory toggle working.
      }
      return next;
    });
  };

  return { theme, toggle };
}
